import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { CartService } from '@account/Services/CartService'

@Injectable()
export class CheckoutGuard implements CanActivate {
	public cartService: CartService

	public router: Router
	constructor() {
		this.cartService = inject(CartService)
		this.router = inject(Router)
	}

	public canActivate(): boolean {
		if (this.cartService.cart.items.length === 0) {
			this.router.navigateByUrl('/cart')

			return false
		}

		return true
	}
}
